module.exports = __webpack_public_path__ + "static/img/netflix-footer-icon.fe30f9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-footer-icon.png
// module id = 219
// module chunks = 1